export default "__VITE_ASSET__wZTqCE8$__"